import { render, staticRenderFns } from "./TruckNumber.vue?vue&type=template&id=e252b334"
import script from "./TruckNumber.vue?vue&type=script&lang=js"
export * from "./TruckNumber.vue?vue&type=script&lang=js"
import style0 from "./TruckNumber.vue?vue&type=style&index=0&id=e252b334&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports